module.exports = __webpack_public_path__ + "static/media/robot-orange-full.4b411c5d.svg";